import React from "react";

export const LoaderContainer = (props) => {
  const { message = "Loading.....", loading, position = "fixed" } = props;
  if (!loading) {
    return "";
  }
  return (
    <div className={`loader-container is-${position}`}>
      <div className="loader-container__content">
        <div className="loader-container__icon">
          <Spinner />
        </div>
        <div className="loader-container__text">{message}</div>
      </div>
    </div>
  );
};

const Spinner = () => {
  return (
    <div className="spinner">
      <span className="spinner__ring"></span>
      <span className="spinner__ring"></span>
    </div>
  );
};
